import { CommonModule, formatDate } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SessionStorageService } from '../../../core/services/session-storage/session-storage.service';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { Router } from '@angular/router';
import { ConfirmPopupComponent } from '../new-rep-application/confirm-popup/confirm-popup.component';
import { HttpStatusCode } from 'axios';
import { DsuManagerAssessmentService } from './dsu-manager-assessment-service/dsu-manager-assessment.service';
import { viewDsuManagerAssessment } from './dsu-manager-assessment-interface/dsu-manager-assessment.interface';
import { DsuManagerAssessmenModel } from './dsu-manager-assessment-models/dsu-manager-assessment.models';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { OnboardingAssessmentService } from '../onboarding-assessment/onboarding-assessment-services/onboarding-assessment.service';
import { OnboardingAssesmentModel } from '../onboarding-assessment/onboarding-assesment-models/onboarding-assesment-model.model';
import { OnboardingAssesment } from '../onboarding-assessment/onboarding-assesment-interface/onboarding-assesment.interface';
import { NewRepChecklistService } from '../new-rep-checklist/new-rep-checklist-services/new-rep-checklist.service';
import { getChecklistItems } from '../new-rep-checklist/new-rep-checklist-interfaces/save-new-rep-checklist.interface';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DocumentPreviewOverlayDirective } from '../../../shared/directives/document-preview-overlay/document-preview-overlay.directive';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-dsu-manager-assessment',
  providers: [provideMomentDateAdapter(MY_FORMATS)],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatIcon,
    MatIconModule,
    MatTooltipModule,
    DocumentPreviewOverlayDirective,
    MatButtonModule,
  ],
  templateUrl: './dsu-manager-assessment.component.html',
  styleUrl: './dsu-manager-assessment.component.scss'
})
export class DsuManagerAssessmentComponent implements OnInit {

  private fb = inject(FormBuilder);
  private readonly matDialog = inject(MatDialog);
  readonly message = ' This field is required.';
  private sanitizer = inject(DomSanitizer);
  private sessionStorageService = inject(SessionStorageService);
  private dsuManagerAssessmentService = inject(DsuManagerAssessmentService);
  private documentUploadService = inject(OnboardingAssessmentService);
  private newRepChecklistService = inject(NewRepChecklistService);
  private snackBarService = inject(SnackbarService);
  private router = inject(Router);
  setSprinner = signal(false);
  submitted = signal(false);
  errormessage!: string;
  designation!: string;

  data = history.state;
  viewId!: number;
  viewDsuManagerAssessment!: viewDsuManagerAssessment;
  isReadOnly = signal(false);
  iseditable = signal(false);
  protected currentUserRole: string = "";
  protected getchecklistItems: getChecklistItems[] = [];
  checklistinvalidflag = signal(false);
  role!: string;

  /** Prefix used for the dynamically added "Other Attachments" controls. */
  readonly otherAttachmentPrefix = 'otherAttachment';
  /** Document type sent for every "Other Attachments" upload - the row index goes in responseValue. */
  readonly otherAttachmentDescription = 'OtherAttachments';
  /** Control keys of the rendered "Other Attachments" rows, e.g. ['otherAttachment1', 'otherAttachment2']. */
  otherAttachmentKeys: string[] = [];
  private otherAttachmentSeq = 0;
  /** The "Other Attachments" rows of this application's uploaded documents. */
  private otherAttachmentDocuments: OnboardingAssesment[] = [];

  public dsumanagerassessmentForm: FormGroup = this.fb.group({
    name: [''],
    manager: [''],
    piasrepcode: ['', [Validators.required]],
    rnfnumber: [''],
    rnfApprovalDate: [''],
    lodgmentDate: [''],
    remarks: [''],
    declarationaccepted: ['', [Validators.required]],
    dsumanagername: [''],
    date: ['']

  });

  selectedDocument!: SafeResourceUrl;
  isPdf = false;
  selectedItemFile!: string;
  currentFileName!: string;

  readonly MIN_ZOOM = 0.5;
  readonly MAX_ZOOM = 3;
  private readonly ZOOM_STEP = 0.25;
  zoomLevel = 1;

  ngOnInit(): void {
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    this.viewId = this.data.id;
    this.designation = this.data.designation;
    this.isReadOnly.set(this.data.isReadOnly);
    this.iseditable.set(this.data.iseditable);
    if (this.designation == 'Introducer - Individual') {
      this.role = 'INDIVIDUAL';
    } else {
      this.role = 'CORPORATE';
    }
    if (!['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)) {
      this.dsumanagerassessmentForm.controls['rnfnumber'].setValidators([Validators.required]);
      this.dsumanagerassessmentForm.controls['rnfApprovalDate'].setValidators([Validators.required]);
      this.dsumanagerassessmentForm.controls['lodgmentDate'].setValidators([Validators.required]);
    }
    this.viewDsumanagerAssessment();
    this.getChecklistItems();
    this.loadOtherAttachments();
    if (this.currentUserRole == 'DSU Manager' && this.iseditable()) {
      this.isReadOnly.set(false);
    }
    if (this.isReadOnly() == true) {
      this.dsumanagerassessmentForm?.disable();
    } else {
      this.dsumanagerassessmentForm?.enable();
    }

    this.dsumanagerassessmentForm.get('declarationaccepted')?.valueChanges.subscribe(value => {
      if (value) {
        this.dsumanagerassessmentForm.patchValue({
          dsumanagername: this.sessionStorageService.getCurrentUserPersonName(),
          date: this.getToday()
        }, { emitEvent: false });
        this.errormessage = '';
      } else {
        this.dsumanagerassessmentForm.patchValue({
          dsumanagername: null,
          date: null
        }, { emitEvent: false });
        if (value == false) {
          this.dsumanagerassessmentForm.get('declarationaccepted')?.markAllAsTouched();
        }
      }
    });

  }

  // ---------- Other Attachments ----------

  /**
   * Fetches this application's uploaded documents and rebuilds the
   * "Other Attachments" rows from the 'OtherAttachments' entries.
   */
  async loadOtherAttachments(): Promise<void> {
    const responseData = await this.documentUploadService
      .viewDsumangerdocumentslist(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    if (responseData.status === HttpStatusCode.Ok) {
      const allDocuments: OnboardingAssesment[] = responseData.data.responsedata ?? [];
      this.otherAttachmentDocuments = allDocuments.filter(
        item => this.otherAttachmentIndexOf(item) !== null
      );
    }

    this.buildOtherAttachments();
  }

  /** The row index sent as responseValue for an "Other Attachments" control key. */
  private otherAttachmentIndex(key: string): string {
    return key.slice(this.otherAttachmentPrefix.length);
  }

  /** Row index of a control key as a number, for matching and ordering. */
  private otherAttachmentRow(key: string): number {
    return Number(this.otherAttachmentIndex(key));
  }

  /**
   * Row index an uploaded document belongs to, or null when it isn't an "Other
   * Attachments" row. Uploads carry 'OtherAttachments' as the document type with
   * the index in responseValue; rows saved before that change kept the index in
   * the document type itself, so both shapes are recognised here. The index is
   * read as a number so a row is still matched when the API echoes it back in a
   * different form (' 2', 2) than the one that was sent.
   */
  private otherAttachmentIndexOf(item: OnboardingAssesment | undefined): number | null {
    const docType = item?.onboardingDocumentType ?? '';
    const raw = docType === this.otherAttachmentDescription
      ? String(item?.responseValue ?? '').trim()
      : docType.startsWith(this.otherAttachmentPrefix)
        ? docType.slice(this.otherAttachmentPrefix.length)
        : '';

    const row = Number(raw);
    return raw !== '' && Number.isFinite(row) ? row : null;
  }

  /** Locates the uploaded document behind an "Other Attachments" row, matched on its index. */
  private findOtherAttachmentDocument(key: string): OnboardingAssesment | undefined {
    const row = this.otherAttachmentRow(key);
    return this.otherAttachmentDocuments.find(item => this.otherAttachmentIndexOf(item) === row);
  }

  /**
   * Restores any previously uploaded "Other Attachments" and always keeps at
   * least one empty row. Safe to call repeatedly (loadOtherAttachments() runs
   * again after every upload) - restoreOtherAttachment() only adds unseen
   * controls.
   */
  private buildOtherAttachments(): void {
    this.otherAttachmentDocuments.forEach(item => {
      const index = this.otherAttachmentIndexOf(item);
      if (index !== null) {
        this.restoreOtherAttachment(`${this.otherAttachmentPrefix}${index}`, item.fileName);
      }
    });

    if (this.otherAttachmentKeys.length === 0) {
      this.addOtherAttachment();
    }

    // The API lists the documents in its own order, so the rows are put back in row
    // order here. Left unsorted the fields swap places on every fetch, and because
    // the template hangs the remove button off every row but the first and the add
    // button off the last, those buttons end up on whichever rows came back first.
    this.otherAttachmentKeys.sort((a, b) => this.otherAttachmentRow(a) - this.otherAttachmentRow(b));
  }

  private restoreOtherAttachment(key: string, fileName: string): void {
    if (!this.otherAttachmentKeys.includes(key)) {
      this.dsumanagerassessmentForm.addControl(key, this.fb.control([null]));
      this.dsumanagerassessmentForm.addControl(`${key}fileName`, this.fb.control(''));
      this.otherAttachmentKeys.push(key);

      const seq = Number(key.slice(this.otherAttachmentPrefix.length));
      if (!Number.isNaN(seq) && seq > this.otherAttachmentSeq) {
        this.otherAttachmentSeq = seq;
      }
    }
    this.dsumanagerassessmentForm.get(`${key}fileName`)?.setValue(fileName);
  }

  /** Duplicates the "Other Attachments" field so another file can be attached. */
  addOtherAttachment(): void {
    const key = `${this.otherAttachmentPrefix}${++this.otherAttachmentSeq}`;
    this.dsumanagerassessmentForm.addControl(key, this.fb.control([null]));
    this.dsumanagerassessmentForm.addControl(`${key}fileName`, this.fb.control(''));
    this.otherAttachmentKeys.push(key);
  }

  /** Removes a duplicated "Other Attachments" row, deleting its uploaded file first when there is one. */
  removeOtherAttachment(key: string): void {
    if (!this.dsumanagerassessmentForm.get(`${key}fileName`)?.value) {
      this.dropOtherAttachment(key);
      return;
    }

    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result?.data === true) {
        await this.deleteOtherAttachmentDocument(key);
        this.dropOtherAttachment(key);
      }
    });
  }

  /** Clears the uploaded file but keeps the "Other Attachments" field on screen. */
  removeOtherAttachmentFile(key: string): void {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result?.data !== true) {
        return;
      }

      await this.deleteOtherAttachmentDocument(key);

      this.dsumanagerassessmentForm.get(key)?.reset();
      this.dsumanagerassessmentForm.get(`${key}fileName`)?.reset();
      const fileInput = document.getElementById(`${key}fileName`) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
      this.dsumanagerassessmentForm.get(`${key}fileName`)?.markAsTouched();
      this.dsumanagerassessmentForm.get(`${key}fileName`)?.updateValueAndValidity();
    });
  }

  private async deleteOtherAttachmentDocument(key: string): Promise<void> {
    const match = this.findOtherAttachmentDocument(key);
    if (!match?.id) {
      return;
    }

    const data = {
      onboardingId: this.viewId,
      docTypeId: match.docTypeId,
      id: match.id
    };

    await this.documentUploadService
      .deleteonbordingdocument(data)
      .then((response) => JSON.parse(response))
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.otherAttachmentDocuments = this.otherAttachmentDocuments.filter(item => item !== match);
  }

  private dropOtherAttachment(key: string): void {
    this.dsumanagerassessmentForm.removeControl(key);
    this.dsumanagerassessmentForm.removeControl(`${key}fileName`);
    this.otherAttachmentKeys = this.otherAttachmentKeys.filter(item => item !== key);
  }

  onOtherAttachmentFileChange(event: any, key: string): void {
    const file = event.target.files?.[0];
    const fileControl = this.dsumanagerassessmentForm.get(`${key}fileName`);

    this.dsumanagerassessmentForm.patchValue({
      [key]: file,
      [`${key}fileName`]: file?.name
    });

    if (!fileControl) return;

    fileControl.markAsTouched();
    fileControl.setErrors(null);

    if (!file) {
      fileControl.setValue(null);
      return;
    }

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!allowedTypes.includes(file.type)) {
      fileControl.setErrors({ invalidType: true });
      return;
    }

    if (file.size > maxSize) {
      fileControl.setErrors({ maxSize: true });
      return;
    }

    fileControl.updateValueAndValidity();
    this.uploadOtherAttachment(key);
  }

  /**
   * Uploads an "Other Attachment" against the application under review. Every
   * row is saved under the shared 'OtherAttachments' category_name and is told
   * apart by its index in responseValue, so the row can be matched back on
   * reload.
   */
  async uploadOtherAttachment(key: string): Promise<void> {
    const file = this.dsumanagerassessmentForm.get(key)?.value;
    if (!(file instanceof Blob)) {
      return;
    }

    this.setSprinner.set(true);
    let uploadOtherAttachments = new OnboardingAssesmentModel();
    uploadOtherAttachments.setOnboardingid(this.viewId);
    uploadOtherAttachments.setupdatedbyrole(this.sessionStorageService.getCurrentUserRole());
    uploadOtherAttachments.setAttachments([{
      onboardingid: this.viewId,
      docTypeId: 0,
      category_name: this.otherAttachmentDescription,
      fileName: (file as File).name,
      data: await this.convertToBase64(file as File),
      contentType: file.type,
      responseValue: this.otherAttachmentIndex(key)
    }]);

    const responseData = await this.documentUploadService
      .saveOnboardingassessment(uploadOtherAttachments)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.snackBarService.openSuccessSnackBar("document uploaded successfully!");
      // Awaited so the row has the saved document's id behind it before the user
      // can act on it - deleting a file uploaded moments earlier would otherwise
      // find no match and clear the field without removing anything.
      await this.loadOtherAttachments();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  showPreview = false;

  async previewAttachment(controlName: string, filename: string) {
    this.selectedItemFile = controlName;
    await this.loadOtherFile(controlName, filename);
    this.showPreview = true;

  }

  private findAttachment(fileVar: string): OnboardingAssesment | undefined {
    const matches = this.otherAttachmentDocuments?.filter(item => this.otherAttachmentIndexOf(item) === this.otherAttachmentRow(fileVar))
    return matches?.[matches.length - 1];
  }

  async loadOtherFile(category: string, filename: string) {

    const documentId = this.findAttachment(category)?.id;

    if (documentId) {
      try {

        const responseData = await this.documentUploadService
          .viewChecklistdocuments(documentId);

        // Create blob URL
        const fileURL = URL.createObjectURL(responseData);


        // Safe URL
        this.selectedDocument =
          this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

      } catch (error) {
        console.error(error);
      }
      this.isPdf = this.dsumanagerassessmentForm.get(filename)?.value.toLowerCase().endsWith('.pdf');
      this.currentFileName = this.dsumanagerassessmentForm.get(filename)?.value;
      this.resetZoom();
    }
  }

  zoomIn(): void {
    this.zoomLevel = Math.min(this.MAX_ZOOM, +(this.zoomLevel + this.ZOOM_STEP).toFixed(2));
  }

  zoomOut(): void {
    this.zoomLevel = Math.max(this.MIN_ZOOM, +(this.zoomLevel - this.ZOOM_STEP).toFixed(2));
  }

  resetZoom(): void {
    this.zoomLevel = 1;
  }

  closePreview() {
    this.showPreview = false;
    this.resetZoom();
  }

  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        const result = reader.result as string;

        // Remove metadata prefix
        const base64 = result.split(',')[1];

        resolve(base64);
      };

      reader.onerror = (error) => reject(error);
    });
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  async viewDsumanagerAssessment() {
    this.setSprinner.set(true);
    let status = this.data.status;
    const responseData = await this.dsuManagerAssessmentService
      .viewDsuManagerAssessment(this.viewId, status)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {

      this.viewDsuManagerAssessment = responseData.data.responsedata;

      this.dsumanagerassessmentForm.controls['name'].setValue(this.viewDsuManagerAssessment.declaration_details.fullNameNric);
      this.dsumanagerassessmentForm.controls['manager'].setValue(this.viewDsuManagerAssessment.declaration_details.finacialServiceMan);
      this.dsumanagerassessmentForm.controls['piasrepcode'].setValue(this.viewDsuManagerAssessment.declaration_details.repCode);
      this.dsumanagerassessmentForm.controls['rnfnumber'].setValue(this.viewDsuManagerAssessment.declaration_details.rnfNo);
      this.dsumanagerassessmentForm.controls['rnfApprovalDate'].setValue(this.viewDsuManagerAssessment.declaration_details.rnfDate);
      this.dsumanagerassessmentForm.controls['lodgmentDate'].setValue(this.viewDsuManagerAssessment.declaration_details.lodgmentDate);
      this.dsumanagerassessmentForm.controls['remarks'].setValue(this.viewDsuManagerAssessment.remark_details.remarkContent);
      this.dsumanagerassessmentForm.controls['declarationaccepted'].setValue(this.viewDsuManagerAssessment.declaration_details.dsuMgrIsAgree);
      if (this.dsumanagerassessmentForm.get('declarationaccepted')?.value == true) {
        this.dsumanagerassessmentForm.controls['dsumanagername'].setValue(this.viewDsuManagerAssessment.declaration_details.dsuMgrName);
        this.dsumanagerassessmentForm.controls['date'].setValue(this.viewDsuManagerAssessment.declaration_details.dsuMgrDeclarationDate?.split('T')[0]);
      }

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  async viewloadgement() {
    this.setSprinner.set(true);
    let status = this.data.status;
    const responseData = await this.dsuManagerAssessmentService
      .viewDsuManagerAssessment(this.viewId, status)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {
      this.viewDsuManagerAssessment = responseData.data.responsedata;
      this.dsumanagerassessmentForm.controls['lodgmentDate'].setValue(this.viewDsuManagerAssessment.declaration_details.lodgmentDate);

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  openConfirmDialog() {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Are you sure you want to submit this Application?',
        hidecancel: false,
      }
    });

    this.getChecklistItems();

    dialogRef.afterClosed().subscribe(result => {
      if (result.data === true) {
        if (this.dsumanagerassessmentForm.get('declarationaccepted')?.value == true) {
          if (this.checklistinvalidflag() === true) {
            this.errormessage = 'Please complete the checklist';
            this.submitted.set(false);
          } else {
            this.submitted.set(true);
            this.saveAndContinue();
          }
        } else {
          this.errormessage = 'Please check the confirm';
          this.submitted.set(false);
        }

      } else {
        // console.log('User cancelled');
      }
    });
  }

  async getChecklistItems() {
    const responseData = await this.newRepChecklistService
      .getChecklistItems(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });


    if (responseData.status === HttpStatusCode.Ok) {

      this.getchecklistItems = responseData.data.responsedata;
      if (['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)) {
        this.checklistinvalidflag.set(
          this.getchecklistItems.length === 0 ||
          this.getchecklistItems
            .some(x => x.isCompleted == null || x.isCompleted == false)
        );
      } else {
        this.getchecklistItems = this.getchecklistItems.filter(
          x => x.categoryName.startsWith('minimumDocumentCheck_') || x.categoryName.startsWith('subsequentDocumentsCheck_')
        );
        const preferredOrder = [
          "minimumDocumentCheck_",
          "subsequentDocumentsCheck_",
        ];

        const getCategoryOrder = (categoryName = "") => {
          const index = preferredOrder.findIndex(prefix =>
            categoryName.startsWith(prefix)
          );
          return index === -1 ? preferredOrder.length : index;
        };

        const getSuffixNumber = (categoryName = "") => {
          const match = categoryName.match(/_(\d+)$/);
          return match ? Number(match[1]) : Number.MAX_SAFE_INTEGER;
        };

        this.getchecklistItems.sort((a, b) => {
          const orderA = getCategoryOrder(a.categoryName);
          const orderB = getCategoryOrder(b.categoryName);

          if (orderA !== orderB) {
            return orderA - orderB;
          }

          return getSuffixNumber(a.categoryName) - getSuffixNumber(b.categoryName);
        });

        this.checklistinvalidflag.set(
          this.getchecklistItems.filter(
            x => x.categoryName?.startsWith('minimumDocumentCheck_')
          ).length === 0 ||
          this.getchecklistItems
            .filter(x => x.categoryName?.startsWith('minimumDocumentCheck_'))
            .some(x => x.isCompleted == null || x.isCompleted == false)
        );
      }

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  async saveLodgment() {
    this.setSprinner.set(true);
    let saveDsuManagerassessment = new DsuManagerAssessmenModel();
    saveDsuManagerassessment.setOnboardingid(this.viewId);
    const formatted = formatDate(
      this.dsumanagerassessmentForm.get('lodgmentDate')?.value,
      'yyyy-MM-dd',
      'en-US'
    );
    saveDsuManagerassessment.setlodgmentdate(formatted + 'T00:00:00Z');

    const responseData = await this.dsuManagerAssessmentService
      .savelodgmentDsuManagerAssessment(saveDsuManagerassessment)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.viewloadgement();
      this.snackBarService.openSuccessSnackBar("loadgement saved successfully!");

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  async saveAndContinue() {
    this.setSprinner.set(true);
    let saveDsuManagerassessment = new DsuManagerAssessmenModel();
    saveDsuManagerassessment.setOnboardingid(this.viewId);
    saveDsuManagerassessment.setRemarkid(this.viewDsuManagerAssessment?.remark_details?.id);
    saveDsuManagerassessment.setrnfNo(this.dsumanagerassessmentForm.get('rnfnumber')?.value);
    if (this.dsumanagerassessmentForm.get('rnfApprovalDate')?.value) {
      const formatted = formatDate(
        this.dsumanagerassessmentForm.get('rnfApprovalDate')?.value,
        'yyyy-MM-dd',
        'en-US'
      );
      saveDsuManagerassessment.setrnfDate(formatted + 'T00:00:00Z');
    }
    saveDsuManagerassessment.setuserRepCode(this.dsumanagerassessmentForm.get('piasrepcode')?.value);
    saveDsuManagerassessment.setRemarkContent(this.dsumanagerassessmentForm.get('remarks')?.value);
    saveDsuManagerassessment.setDsumanagerName(this.dsumanagerassessmentForm.get('dsumanagername')?.value);
    if (this.submitted() == true) {
      saveDsuManagerassessment.setIs_completed(this.dsumanagerassessmentForm.get('declarationaccepted')?.value);
      saveDsuManagerassessment.setDeclaration_date(this.dsumanagerassessmentForm.get('date')?.value + 'T00:00:00Z');
    } else {
      saveDsuManagerassessment.setIs_completed(false);
    }

    const responseData = await this.dsuManagerAssessmentService
      .saveDsuManagerAssessment(saveDsuManagerassessment)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.viewDsumanagerAssessment();
      if (this.submitted() == true) {
        this.snackBarService.openSuccessSnackBar("Application submitted successfully!");
        this.router.navigate(['/agent-onboarding']);
      } else {
        this.snackBarService.openSuccessSnackBar("Application saved successfully!");
      }
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }

  }
}
